// extracted by mini-css-extract-plugin
export default {"data":"TableDataCell_data__XVWn5"};